<template>
  <div class="contact-page">
    <ContactThankYouPending />
  </div>
</template>

<script>
import ContactThankYouPending from '../components/elements/pages/ContactThankYouPending.vue'
export default {
  name: 'ContactThanksPending',
  metaInfo: {
    title: 'Contact Us'
  },
  components: {
    ContactThankYouPending
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
</style>
